export default __webpack_public_path__ + "static/media/green-3.8b8ab8a6.svg";